import { Card, Icon, Popup } from "semantic-ui-react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { firebase } from "astrid-firebase";
import { Contractor } from "astrid-firestore/src/api/contractors/types/Contractor";
import updateContractor from "astrid-firestore/src/api/contractors/updateContractor";
import { isLocal, isStage } from "astrid-helpers/src/env";

import PrimaryButton from "../../../ui/components/Buttons/PrimaryButton";

import { useProfile } from "../../../authentication/state/profile";
import Form from "../../../forms/components/Form/Form";
import useSimpleForm from "../../../forms/hooks/useSimpleForm";

export default function ContractorView({ contractor }) {
	const { t } = useTranslation();
	const user = useProfile();
	const host = window.location.origin;

	const [copied, setCopied] = useState(false);

	const { form, watch, formState, onSubmit } = useSimpleForm({
		schema: Contractor,
		defaultValues: {
			name: contractor.name || "",
			allowExternalUpload: contractor.allowExternalUpload || false,
			password: null,
		},
		onSubmit: (data) => updateContractor(firebase, contractor.ref, { updatedBy: user, ...data }),
	});

	const externalLink =
		isLocal || isStage
			? `${host}/external-upload/${contractor.id}`
			: `https://astrid.fm/external-upload/${contractor.id}`;

	const { allowExternalUpload } = watch();

	return (
		<>
			<Card fluid>
				<Card.Content>
					<Form form={form}>
						<Form.Input name="name" label={t("name", "Name")} />

						<Form.Checkbox
							name="allowExternalUpload"
							label={t("allowExternalUpload", "Allow external file upload")}
							slider
						/>

						{allowExternalUpload && (
							<Form.Group widths="equal">
								<Form.Input
									name="url"
									label="URL"
									action={
										<Popup
											content={t("copied", "Copied")}
											on={copied}
											trigger={
												<PrimaryButton
													icon
													onClick={() => {
														navigator.clipboard.writeText(externalLink);
														setCopied(true);
													}}
													style={{ padding: 10 }}
												>
													<Icon name="copy outline" />
												</PrimaryButton>
											}
										/>
									}
									defaultValue={externalLink}
								/>

								<Form.Input name="password" label={t("updatePassword", "Update password")} />
							</Form.Group>
						)}
					</Form>
				</Card.Content>

				<Card.Content>
					<PrimaryButton
						disabled={formState.isSubmitting || !formState.isDirty}
						loading={formState.isSubmitting}
						onClick={onSubmit}
					>
						{t("save", "Save")}
					</PrimaryButton>
				</Card.Content>
			</Card>
		</>
	);
}
